import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import {
  Card,
  CardBody,
  CardImg,
  CardText,
  Spinner,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";
import { useDispatch } from "react-redux";

function ArticleDetails({ articleId }) {
  const dispatch = useDispatch();
  const [articleDetails, setArticleDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [disableNavigation, setDisableNavigation] = useState(false);

  const fetchDetails = async () => {
    try {
      setLoading(true);
      const getDetails = await ApiClient.get(
        `api/admin/get-article-by-id/${articleId}`,
        "",
        true,
        dispatch
      );
      if (getDetails?.status === true) {
        setArticleDetails(getDetails.body);
        setLoading(false);
      } else {
        toast.error(getDetails.message, { autoClose: 3000 });
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (articleId) {
      fetchDetails();
    }
  }, [articleId]);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === articleDetails.articleImagesThumbnail.length - 1
        ? 0
        : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0
        ? articleDetails.articleImagesThumbnail.length - 1
        : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  useEffect(() => {
    if (articleDetails?.articleImagesThumbnail.length === 1) {
      setDisableNavigation(true);
    } else {
      setDisableNavigation(false);
    }
  }, [articleDetails]);

  if (loading) {
    return <Spinner color="primary">Loading...</Spinner>;
  }

  if (!articleDetails) {
    return <div>No article details found</div>;
  }

  const slides = articleDetails.articleImagesThumbnail.map((image, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={index}
      >
        <CardImg src={image.url} alt={image.altText} />
        <CarouselCaption
          captionText={image.caption}
          captionHeader={image.caption}
        />
      </CarouselItem>
    );
  });

  return (
    <div>
      {/* Render article images in a carousel */}
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        interval={false}
        keyboard={false}
        ride={false}
        controls={!disableNavigation}
        indicators={!disableNavigation}
      >
        <CarouselIndicators
          items={articleDetails.articleImagesThumbnail}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
          className={disableNavigation ? "d-none" : ""}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
          className={disableNavigation ? "d-none" : ""}
        />
      </Carousel>
      {/* Render article title and name */}
      <h2 className="article_name">{articleDetails.articleName}</h2>
      <h3 className="article_title">{articleDetails.title}</h3>
      {/* Render article description */}
      <div className="article_desc" dangerouslySetInnerHTML={{ __html: articleDetails?.description }}/>
     
    </div>
  );
}

export default ArticleDetails;